export default "__VITE_ASSET__CAXmmxOY__"